<template>
  <div id="app">
    <keep-alive exclude="Joinpreview,teamdetail">
      <router-view />
    </keep-alive>
    <h5loading v-show="loadingTxt">{{loadingTxt}}</h5loading>
  </div>
</template>

<script>
import { debounce } from './utils/utils'
import h5loading from '@/components/loading'
import { mapState, mapActions, mapMutations } from 'vuex'
import { getWechatSdk } from '@/data/api'
import VConsole from 'vconsole'
export default {
  created () {
    console.log(process.env.NODE_ENV)
    this.setRem()
    this.setRem = debounce(this.setRem, 500)
    window.onresize = this.setRem
    this.getDefaultA()
    this.setIsIos(/\(i[^;]+;( U;)? CPU.+Mac OS X/.test(window.navigator.userAgent))

    if (process.env.NODE_ENV === 'development') {
      const vConsole = new VConsole()
    }
  },
  components: {
    h5loading
  },
  computed: {
    ...mapState(['loadingTxt', 'actiBol'])
  },
  methods: {
    ...mapMutations(['setIsIos']),
    ...mapActions(['getDefaultA']),
    setRem () {
      const dom = document.documentElement
      dom.style.fontSize = dom.clientWidth / 7.5 + 'px'
      console.log(dom.clientWidth)
    }
  }
}
</script>

<style>
*{margin:0;padding:0;outline: none;}
.oneline{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis
}
.noscroll{
  position: fixed;
  width: 100%;
  height:100%;
  overflow: hidden;
}
html{
  height:100vh;
}
body, #app{
  height:100%;
  font-size: 0.16rem;
}
</style>
